import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "@/assets/reset.css";
import Axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

const $Axios = Axios.create({
  headers: {
      'Accept': '*/*',
      'Content-Type' : 'application/json'
  },
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 600000
})

Vue.prototype.$Axios = $Axios
Vue.use(ElementUI,{
  size: "mini"
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
